import React from 'react';

import PropTypes from 'prop-types';
import Message from 'presentation/components/Message';
import classnames from 'classnames/bind';
import styles from 'presentation/components/styles/Message.css';

let cx = classnames.bind(styles);

export default function WelcomeMessage(props) {
  const welcomeMessagePropTypes = {
    welcomeMessage: PropTypes.string,
  };

  let welcomeMessageClasses = cx(styles.welcomeMessage);

  PropTypes.checkPropTypes(welcomeMessagePropTypes, props, 'prop', 'welcomeMessage');
  return (
    <Message
      className={welcomeMessageClasses}
      sender={''}
      content={props.welcomeMessage}
      data-aid="gladlyChatWelcomeMessage"
    />
  );
}
